import { useFieldArray, useFormContext } from "react-hook-form";

import { Paper, Stack, Typography } from "@mui/material";

import { formatNumber } from "@/features/shared";
import { CustomTable } from "@/features/ui";

export const SalesOrderLensProductSection = () => {
  const { control, getValues } = useFormContext();

  const lensProductName = getValues("name");
  const addOn = getValues("addOn");

  const { fields: salesOrderLensProductVariants } = useFieldArray({
    control,
    name: "salesOrderLensProductVariants",
  });

  const columns = [
    { field: "side", headerName: "Sisi" },
    { field: "sku", headerName: "SKU" },
    {
      field: "variant",
      headerName: "Varian",
      renderCell: ({
        variantAttribute1Value,
        variantAttribute2Value,
        variantAttribute3Value,
        note,
      }) => {
        // Get axis from note
        let axis = "-";
        try {
          const parsed = JSON.parse(note || "{}");
          axis = parsed.axis || "0";
        } catch {
          // Ignore JSON parse errors
        }

        // Build prescription: {variant_attribute_1_value}/{variant_attribute_2_value}/{axis}/{variant_attribute_3_value}
        const value1 = variantAttribute1Value || "-";
        const value2 = variantAttribute2Value || "-";
        const value3 = variantAttribute3Value || "0"; // Use "0" if null

        const prescription = `${value1}/${value2}/${axis}/${value3}`;

        return prescription;
      },
    },
    {
      field: "pd",
      headerName: "PD",
      renderCell: ({ note }) => {
        try {
          const parsed = JSON.parse(note || "{}");
          return parsed.pd ?? "-";
        } catch {
          return "-";
        }
      },
    },
    {
      field: "prism",
      headerName: "Prism",
      renderCell: ({ note }) => {
        try {
          const parsed = JSON.parse(note || "{}");
          return parsed.prism ?? "-";
        } catch {
          return "-";
        }
      },
    },
    {
      field: "price",
      headerName: "Harga",
      align: "right",
      renderCell: ({ price }) => formatNumber(price),
    },
  ];

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Stack spacing={2}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography>{lensProductName}</Typography>
        </Stack>
        <CustomTable
          columns={columns}
          rows={salesOrderLensProductVariants}
          keyField="side"
        />
        <Typography>
          Add On:{" "}
          {addOn ? (
            <Typography component="span" color="error" sx={{
              fontWeight: "500"
            }}>
              {addOn}
            </Typography>
          ) : (
            "-"
          )}
        </Typography>
      </Stack>
    </Paper>
  );
};
